// src/components/vision/VisionHeroSection.tsx
import React from 'react';
import { motion } from 'framer-motion';
import VisionHeroVisual from '../../visuals/VisionHeroVisual'; // <-- IMPORT THE NEW VISUAL
import { ArrowDown } from 'lucide-react';

interface HeroData {
  headline: string;
  intro: string;
}

interface VisionHeroSectionProps {
  heroData: HeroData;
}

export const VisionHeroSection: React.FC<VisionHeroSectionProps> = ({ heroData }) => {
  // Smooth scroll to the next section
  const scrollToNextSection = () => {
    const nextSection = document.querySelector('.story-section-anchor');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    // Switched to a dark, centered, and more impactful layout
    <section className="bg-slate-900 text-white relative overflow-hidden py-20 md:py-28">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(#2e3c51_1px,transparent_1px)] [background-size:32px_32px] [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_100%)] opacity-50"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10 flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-slate-100 to-slate-400 leading-tight drop-shadow-lg">
            {heroData.headline}
          </h1>
          <p className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-slate-300 leading-relaxed">
            {heroData.intro}
          </p>
        </motion.div>

        {/* The New "Genesis" Visual Component */}
        <div className="mt-12 md:mt-16 w-full">
            <VisionHeroVisual />
        </div>

        {/* Subtle CTA to scroll down */}
        <motion.button
          onClick={scrollToNextSection}
          className="mt-12 text-slate-400 hover:text-white transition-colors duration-300 flex items-center gap-2"
          aria-label="Scroll to next section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 1 }}
        >
          Explore Our Story
          <ArrowDown size={16} />
        </motion.button>
      </div>
    </section>
  );
};